define(
({
  "load_error": "Błąd wczytywania",
  "description": "Żądanie nie zostało poprawnie wypełnione. Upewnij się, że zamówienie zostało zapisane, a następnie odśwież stronę."
})
);
